import styled from '@emotion/styled';
import { theme } from '../../../theme/theme';

interface TextSmallProps {
  lineHeight?: React.CSSProperties['lineHeight'];
  textAlign?: React.CSSProperties['textAlign'];
  color?: React.CSSProperties['color'];
  children: React.ReactNode;
}

export function TextSmall(props: TextSmallProps) {
  return (
    <S.Root
      style={{
        '--text-small-line-height': props.lineHeight,
        '--text-small-text-align': props.textAlign,
        '--text-small-color': props.color,
      }}
    >
      {props.children}
    </S.Root>
  );
}

interface CSSProperties {
  '--text-small-line-height'?: TextSmallProps['lineHeight'];
  '--text-small-text-align'?: TextSmallProps['textAlign'];
  '--text-small-color'?: TextSmallProps['color'];
}

const S = (TextSmall.S = class S {
  static Root = styled.div<{ style: CSSProperties }>`
    font-size: ${theme.fontSize.small};
    font-weight: ${theme.fontWeight.regular};
    line-height: var(--text-small-line-height, 20px);
    text-align: var(--text-small-text-align, start);
    color: var(--text-small-color, ${theme.color.text});
  `;
});
